import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function generateReportPDF({ reportType, reportInfo, clientInfo, dateRangeInfo, filters, reportData }) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header
  doc.setFontSize(20);
  doc.setTextColor(47, 87, 143);
  doc.text("PEBBLES", 14, 20);

  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text(reportInfo?.title || "Report", 14, 32);

  // Meta info
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Client: ${clientInfo?.name || "All Clients"}`, 14, 42);
  doc.text(`Period: ${dateRangeInfo?.label || "N/A"}`, 14, 48);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 14, 54);

  // Summary section
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text("Summary", 14, 68);

  let yPos = 74;
  Object.entries(reportData.summary).forEach(([key, value]) => {
    const label = key.replace(/([A-Z])/g, " $1").trim();
    const displayValue =
      typeof value === "number" && value > 100
        ? `₹${value.toLocaleString()}`
        : typeof value === "number" && key.includes("growth")
        ? `${value > 0 ? "+" : ""}${value}%`
        : String(value);
    
    doc.setFontSize(10);
    doc.text(`${label}: ${displayValue}`, 14, yPos);
    yPos += 6;
  });

  // Table
  const tableData = reportData.rows.map((row) =>
    Object.values(row).map((val) =>
      typeof val === "number" && val > 100 ? `₹${val.toLocaleString()}` : String(val)
    )
  );

  autoTable(doc, {
    startY: yPos + 10,
    head: [reportData.columns],
    body: tableData,
    theme: "striped",
    headStyles: {
      fillColor: [47, 87, 143],
      textColor: 255,
      fontStyle: "bold",
    },
    styles: {
      fontSize: 9,
      cellPadding: 4,
    },
    alternateRowStyles: {
      fillColor: [245, 244, 241],
    },
  });

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text(
      `Page ${i} of ${pageCount}`,
      pageWidth / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: "center" }
    );
  }

  // Download
  const fileName = `${reportType}_report_${clientInfo?.name || "all"}_${new Date().toISOString().split("T")[0]}.pdf`;
  doc.save(fileName.replace(/\s+/g, "_").toLowerCase());
}
